import React from "react";
import {
  easeTransition,
  imageTransition,
  scaleAnimations,
} from "../../misc/framer";
import { motion, Variants } from "framer-motion";
import styled from "styled-components";

export default function ProductImage({
  className,
  image,
  alt,
  isJsx,
  jsxImage,
  inCart,
  inDetail,
  hasAnimation,
  variants,
  isBig,
  isHighlight,
  inHome,
}: {
  className?: string;
  image: string;
  alt: string;
  hasDarkBackground?: boolean;
  inCart?: boolean;
  inDetail?: boolean;
  isJsx?: boolean;
  jsxImage?: JSX.Element;
  hasAnimation?: boolean;
  variants?: Variants;
  isBig?: boolean;
  isHighlight?: boolean;
  inHome?: boolean;
}) {
  return (
    <ImgContainer
      className={`${className} ${inCart ? "cart" : ""} ${
        inDetail ? "detail" : ""
      }`}
    >
      <motion.div variants={variants} transition={easeTransition}>
        {isJsx ? (
          <FilteredImageWrap
            variants={hasAnimation ? scaleAnimations : undefined}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={imageTransition}
            className={`${inCart ? "cart" : ""} ${inDetail ? "detail" : ""} ${
              isBig ? "big" : ""
            } ${isHighlight ? "highlight" : ""} ${inHome ? "home" : ""}`}
          >
            <ProductImg>{jsxImage}</ProductImg>
          </FilteredImageWrap>
        ) : (
          <ProductImgTag
            src={image}
            alt={alt}
            variants={hasAnimation ? scaleAnimations : undefined}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={imageTransition}
          />
        )}
      </motion.div>
    </ImgContainer>
  );
}

const ImgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  &.cart {
    padding: 0;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.laptopS}px`}) {
    padding: 0;
    width: fit-content;
    justify-content: flex-start;

    &.detail {
      width: auto;
      height: auto;
    }
  }
`;

const FilteredImageWrap = styled(motion.div)`
  width: ${({ theme }) => theme.sizes.productSize};
  height: ${({ theme }) => theme.sizes.productSize};
  object-fit: cover;
  overflow: hidden;
  position: relative;

  &.detail {
    width: 100%;
    height: auto;
  }

  &.cart {
    width: ${({ theme }) => `${theme.sizes.productSizeCart}`};
    height: ${({ theme }) => `${theme.sizes.productSizeCart}`};
  }

  &.big {
    width: ${({ theme }) => theme.sizes.productSizeBig};
    height: ${({ theme }) => theme.sizes.productSizeBig};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    width: ${({ theme }) => theme.sizes.productSizeMobile};
    height: ${({ theme }) => theme.sizes.productSizeMobile};
    &.detail {
      width: auto;
      height: auto;
    }
    &.home {
      width: ${({ theme }) => theme.sizes.productSize};
      height: ${({ theme }) => theme.sizes.productSize};
    }
  }

  &.highlight {
    width: ${({ theme }) => theme.sizes.productSizeHighlight};
    height: ${({ theme }) => theme.sizes.productSizeHighlight};
    border-radius: 2px;
    @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
      width: ${({ theme }) => theme.sizes.productSizeMobile};
      height: ${({ theme }) => theme.sizes.productSizeMobile};
    }
  }
`;

const ProductImg = styled.div`
  height: 100%;
`;

const ProductImgTag = styled(motion.img)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 65%;
  width: 100%;
  display: block;
`;
